var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDeleteNotactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M7.971,0.061c-4.387,0-7.944,3.557-7.944,7.945c0,4.385,3.557,7.944,7.944,7.944 c4.387,0,7.944-3.559,7.944-7.944C15.915,3.618,12.357,0.061,7.971,0.061z M10.967,10.099c0.249,0.249,0.249,0.652,0,0.901 c-0.126,0.126-0.289,0.188-0.453,0.188c-0.161,0-0.325-0.062-0.449-0.188L7.971,8.908L5.876,11 c-0.125,0.126-0.288,0.188-0.451,0.188c-0.163,0-0.327-0.062-0.452-0.188c-0.249-0.249-0.249-0.652,0-0.901l2.094-2.093L4.974,5.911 c-0.249-0.249-0.249-0.653,0-0.901c0.25-0.25,0.654-0.25,0.902,0l2.094,2.092l2.094-2.092c0.249-0.25,0.652-0.25,0.902,0 c0.249,0.248,0.249,0.652,0,0.901L8.874,8.005L10.967,10.099z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteNotactive);
export default __webpack_public_path__ + "static/media/icon-delete-notactive.7f52321d.svg";
export { ForwardRef as ReactComponent };